import { RiskPolicy } from "@design-controls/types";
import i18n from "../i18n/config";

export type RiskMatrixSize = "3x3" | "5x5";

export const INITIAL_RISK_PROBABILITY: Record<RiskMatrixSize, Array<string>> = {
  "3x3": [
    i18n.t("risks.iso.levels.low"),
    i18n.t("risks.iso.levels.medium"),
    i18n.t("risks.iso.levels.high"),
  ],
  "5x5": [
    i18n.t("risks.iso.probability.improbable"),
    i18n.t("risks.iso.probability.remote"),
    i18n.t("risks.iso.probability.occasional"),
    i18n.t("risks.iso.probability.probable"),
    i18n.t("risks.iso.probability.frequent"),
  ],
};

export const RISK_MATRIX_DIMENSION: ReadonlyArray<RiskMatrixSize> = [
  "3x3",
  "5x5",
];

export const INITIAL_RISK_SEVERITY: Record<RiskMatrixSize, Array<string>> = {
  "3x3": [
    i18n.t("risks.iso.severity.negligible"),
    i18n.t("risks.iso.severity.moderate"),
    i18n.t("risks.iso.severity.significant"),
  ],
  "5x5": [
    i18n.t("risks.iso.severity.negligible"),
    i18n.t("risks.iso.severity.minor"),
    i18n.t("risks.iso.severity.serious"),
    i18n.t("risks.iso.severity.major"),
    i18n.t("risks.iso.severity.critical"),
  ],
};

export const INITIAL_RISK_LEVEL_MAPPING: Record<
  RiskMatrixSize,
  Array<Array<string>>
> = {
  "3x3": [
    [
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.medium"),
    ],
    [
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.medium"),
      i18n.t("risks.iso.levels.medium"),
    ],
    [
      i18n.t("risks.iso.levels.medium"),
      i18n.t("risks.iso.levels.medium"),
      i18n.t("risks.iso.levels.high"),
    ],
  ],
  "5x5": [
    [
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.low"),
    ],
    [
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.medium"),
      i18n.t("risks.iso.levels.medium"),
    ],
    [
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.medium"),
      i18n.t("risks.iso.levels.medium"),
    ],
    [
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.medium"),
      i18n.t("risks.iso.levels.medium"),
      i18n.t("risks.iso.levels.high"),
    ],
    [
      i18n.t("risks.iso.levels.low"),
      i18n.t("risks.iso.levels.medium"),
      i18n.t("risks.iso.levels.medium"),
      i18n.t("risks.iso.levels.high"),
      i18n.t("risks.iso.levels.high"),
    ],
  ],
};

export const INITIAL_RISK_CONFIGURATION_VALUES: RiskPolicy = {
  codePrefix: i18n.t("risks.initialConfiguration.codePrefix"),
  label: i18n.t("risks.initialConfiguration.label"),
  codeStrategy: "GENERATED",
  type: "risk",
  assessment: {
    iso: {
      levels: [
        i18n.t("risks.iso.levels.low"),
        i18n.t("risks.iso.levels.medium"),
        i18n.t("risks.iso.levels.high"),
      ],
      acceptableLevels: [
        i18n.t("risks.iso.levels.low"),
        i18n.t("risks.iso.levels.medium"),
      ],
      probability: INITIAL_RISK_PROBABILITY["5x5"],
      severity: INITIAL_RISK_SEVERITY["5x5"],
      levelMapping: INITIAL_RISK_LEVEL_MAPPING["5x5"],
    },
  },
};
